<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12>
        <div class="display-1 font-weight-medium mb-4">
          <v-icon large class="mr-2">mdi-view-dashboard-outline</v-icon>
          ManageEngine Overview
        </div>
      </v-flex>

      <v-flex xs12 sm6 v-for="item in settingsItems" :key="item.route">
        <v-card
          class="settings-card"
          hover
          :to="item.route"
        >
          <v-card-title class="pb-1 pt-3">
            <v-icon :color="item.color" size="36" class="mr-3">{{ item.icon }}</v-icon>
            <h3 class="card-title font-weight-medium">{{ item.title }}</h3>
          </v-card-title>
          <v-card-text class="pt-1 pb-3 body-1 grey--text text--darken-1">
            {{ item.description }}
          </v-card-text>
          <div class="card-accent" :style="{ backgroundColor: item.color }"></div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "ManageEngine Overview",
    };
  },
  data: () => ({
    settingsItems: [
      {
        title: "Technicians",
        description: "Manage ManageEngine technicians and their assignments",
        icon: "mdi-worker",
        color: "#4CAF50",
        route: "/helpdesk/manageengine-technicians",
      },
      {
        title: "Sites",
        description: "Manage ManageEngine sites and locations",
        icon: "mdi-map-marker",
        color: "#2196F3",
        route: "/helpdesk/manageengine-sites",
      },
      {
        title: "Categories",
        description: "Manage ManageEngine ticket categories",
        icon: "mdi-shape",
        color: "#FF9800",
        route: "/helpdesk/manageengine-categories",
      },
      {
        title: "Acknowledges",
        description: "Manage ManageEngine acknowledge templates",
        icon: "mdi-check-circle",
        color: "#9C27B0",
        route: "/helpdesk/manageengine-acknowledges",
      },
      {
        title: "Priorities",
        description: "Manage ManageEngine priorities",
        icon: "mdi-priority-low",
        color: "#7f8c8d",
        route: "/helpdesk/manageengine-priorities",
      },
    ],
  }),
};
</script>

<style scoped>
.settings-card {
  position: relative;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  cursor: pointer;
  min-height: 120px;
}

.settings-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

.card-accent {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
}
</style>
